import Vue from 'vue'

import {bindDraggable, registerDraggable} from "./drag-support";
import {registerDropContainer} from "./drop-support";
import {registerHandle} from "./handle-support";

const ARGUMENTS = {
  'drag': 1,
  'drop': 1,
  'handle': 1, // if we want to dnd some parent only by a title
}

export function initDragAndDrop() {
  Vue.directive('dnd', {
    bind(element,
         binding,
         vnode,
         oldVnode) {
      if (!binding.arg) {
        throw new Error("Argument not defined for the `v-dnd`")
      }

      if (!(binding.arg in ARGUMENTS)) {
        throw new Error(`${binding.arg} is not in ${Object.keys(ARGUMENTS)}`)
      }

      if (binding.arg == 'drag') {
        bindDraggable(element, binding, vnode, oldVnode)
      }
    },

    inserted(element,
             binding,
             vnode,
             oldVnode) {
      if (!binding.arg) {
        throw new Error("Argument not defined for the `v-dnd`")
      }

      if (!(binding.arg in ARGUMENTS)) {
        throw new Error(`${binding.arg} is not in ${Object.keys(ARGUMENTS)}`)
      }

      if (binding.arg == 'drag') {
        registerDraggable(element, binding, vnode, oldVnode)
      }

      if (binding.arg == 'drop') {
        registerDropContainer(element, binding, vnode, oldVnode)
      }

      if (binding.arg == 'handle') {
        registerHandle(element, binding, vnode, oldVnode)
      }
    },
  })
}